
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  image: null,
  anonymous: false,
  token: null,
  user: null,
  stateRefresh: false,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setImage: (state, action) => {
      state.image = action.payload;
    },
    setAnonymous: (state, action) => {
      state.anonymous = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setStateRefresh: (state, action) => {
      state.stateRefresh = action.payload;
    },
    resetGlobalState: () => initialState,
  },
});

export const {
  setImage,
  setAnonymous,
  setUser,
  setToken,
  setStateRefresh,
  resetGlobalState,
} = globalSlice.actions;

export default globalSlice.reducer;
